import Layout from '@/components/Layout';
import { MonitorForm } from '@/components/MonitorForm';
import { useAuth } from "@/context/AuthContext";

const CreateMonitor = () => {
    const { axiosInstance } = useAuth();
    
    const handleCreateMonitor = async (formData) => {
        const response = await axiosInstance.post('/monitors', formData);
        return response;
    };

    return (
        <Layout noContainer>
            <MonitorForm onSubmit={handleCreateMonitor} />
        </Layout>
    );
};

export default CreateMonitor;
